import React from "react";
import { TreePine } from "lucide-react";

/** Tree glyph — EVIQ's tree-pledge icon. */
export const BonsaiTree = ({ size = 16, color = "#39FF14", className, style }) => (
  <TreePine
    width={size}
    height={size}
    className={className}
    style={{ color, ...style }}
    strokeWidth={2}
    aria-hidden="true"
  />
);
